import type { PortalSettings } from "../schema";

/**
 * Resolves whether a given form should use the new in-portal forms experience rather than the
 * legacy embedded frame.
 *
 * @param settings - the portal's settings, if the schema has loaded
 * @param formId - the form being opened (`form.id`, or `formResponse.formId`)
 */
export const isNewFormsExperienceEnabledForForm = (
  settings: PortalSettings | undefined,
  formId: string | undefined
): boolean => {
  const mode = settings?.newFormsExperience;
  if (mode === "all") return true;
  if (mode !== "selected" && mode !== "all_except") return false;

  // Without an id there is no way to tell whether this form is on the list, so fall back to the
  // legacy frame rather than guessing a form onto the newer renderer.
  if (!formId) return false;

  const isListed = (settings?.newFormsExperienceFormIds ?? []).includes(formId);
  return mode === "selected" ? isListed : !isListed;
};
